import { Alert, Button } from "@mui/material";
import { useBillingBanner } from "../hooks/useBillingBanner";

export function BillingBanner() {
  const vm = useBillingBanner();

  if (vm.hidden) return null;

  return (
    <Alert
      severity={vm.severity}
      square
      data-testid="billing-banner"
      action={
        <Button color="inherit" size="small" onClick={vm.onAction}>
          {vm.actionLabel}
        </Button>
      }
    >
      {vm.message}
    </Alert>
  );
}
